"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaIcon = _interopRequireWildcard(require("../luna-icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaIconAction = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var _ref$other = _ref.other;
      _ref$other = _ref$other === void 0 ? {} : _ref$other;
      var form = _ref$other.form;
      return form;
    },
    message: 'The form attribute has been promoted to a first-class attribute at LunaIconAction#form. LunaIconAction#other.form will be ignored in v4, please use LunaIconAction#form instead',
    breakingVersion: 4
  }], props);
  var label = props.label,
      glyph = props.glyph,
      component = props.component,
      componentProps = props.componentProps,
      form = props.form,
      labelPosition = props.labelPosition,
      className = props.className,
      disabled = props.disabled,
      htmlType = props.htmlType,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      size = props.size,
      type = props.type,
      other = props.other;

  if (!type || !size || !glyph) {
    throw new Error('LunaIconAction: missing size, type, or glyph prop');
  }

  if (label && !labelPosition) {
    throw new Error("LunaIconAction: if using 'label' prop, must specify 'labelPosition'");
  }

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        sizes = _config.classes.sizes,
        types = _config.classes.types,
        isDisabled = _config.classes.isDisabled,
        withLabel = _config.classes.withLabel,
        labelPlacement = _config.classes.labelPlacement;
    return (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, isDisabled, disabled), _defineProperty(_classnames, types.t5, type === _config.LunaIconActionTypes.t5), _defineProperty(_classnames, types.t10, type === _config.LunaIconActionTypes.t10), _defineProperty(_classnames, types.t20, type === _config.LunaIconActionTypes.t20), _defineProperty(_classnames, types.t30, type === _config.LunaIconActionTypes.t30), _defineProperty(_classnames, sizes.s10, size === _config.LunaIconActionSizes.s10), _defineProperty(_classnames, sizes.s20, size === _config.LunaIconActionSizes.s20), _defineProperty(_classnames, sizes.s30, size === _config.LunaIconActionSizes.s30), _defineProperty(_classnames, sizes.s40, size === _config.LunaIconActionSizes.s40), _defineProperty(_classnames, withLabel, label), _defineProperty(_classnames, labelPlacement.bottom, !labelPosition || labelPosition === _config.LunaIconActionLabelPlacement.bottom), _defineProperty(_classnames, labelPlacement.right, labelPosition === _config.LunaIconActionLabelPlacement.right), _defineProperty(_classnames, labelPlacement.left, labelPosition === _config.LunaIconActionLabelPlacement.left), _defineProperty(_classnames, labelPlacement.above, labelPosition === _config.LunaIconActionLabelPlacement.above), _classnames), className);
  };

  var getIconClass = function getIconClass() {
    var icon = _config.classes.icon;
    return (0, _classnames3["default"])(_defineProperty({}, icon, true));
  };

  var getComponentType = function getComponentType() {
    return component || 'button';
  };

  var Component = getComponentType();

  var getButtonProps = function getButtonProps() {
    var buttonProps = {};

    if (Component === 'button') {
      buttonProps.type = htmlType || 'button';
      buttonProps.form = form || other.form;
    }

    return buttonProps;
  };

  return _react["default"].createElement(Component, _extends({}, other, componentProps, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref,
    disabled: disabled
  }, getButtonProps()), _react["default"].createElement(_lunaIcon["default"], {
    className: getIconClass(true),
    glyph: glyph
  }), label && _react["default"].createElement("span", {
    className: _config.classes.labelContent
  }, label));
});

LunaIconAction.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  form: _propTypes["default"].string,
  glyph: _propTypes["default"].oneOf(Object.values(_lunaIcon.LunaGlyphs)),
  htmlType: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaIconActionSizes)),
  type: _propTypes["default"].oneOf(Object.values(_config.LunaIconActionTypes)),
  labelPosition: _propTypes["default"].oneOf(Object.values(_config.LunaIconActionLabelPlacement)),
  label: _propTypes["default"].string,
  component: _propTypes["default"].elementType,
  componentProps: _propTypes["default"].object
};
LunaIconAction.defaultProps = {
  labelPosition: _config.LunaIconActionLabelPlacement.right,
  other: {}
};
LunaIconAction.displayName = 'LunaIconAction';
var _default = LunaIconAction;
exports["default"] = _default;
